import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";

/** @typedef {import('./utilities').TextComponent} TextComponent */
/**
 * @typedef {Object} ComplimentaryShippingRefs
 * @property {TextComponent} amount - The amount element displaying the extra amount needed
 */

/**
 * A custom element for displaying complimentary shipping progress.
 *
 * @extends {Component<ComplimentaryShippingRefs>}
 */

class ComplimentaryShipping extends Component {
  requiredRefs = ["amount"];

  /** @type {MutationObserver | null} */
  #observer = null;

  /** @type {Element | null} */
  #shippingCountry = document.querySelector('.shipping-calculator__location-tax-notice');

  async connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      ThemeEvents.itemQuantityUpdate,
      this.#handleCartUpdate
    );

    this.#handleDataCountry();
    this.#setupObserver();
  }

  #handleCartUpdate = () => {
    this.refs?.amount?.shimmer();
  };

  #handleDataCountry = () => {
    if (!this.#shippingCountry) return;

    const countryDataAttr = this.#shippingCountry.getAttribute('data-country');

    if(countryDataAttr && countryDataAttr === 'GB') {
      this.classList.remove('complimentary-shipping--hidden');
    } else {
      this.classList.add('complimentary-shipping--hidden');
    }
  };
  
  #setupObserver = () => {
    if (!this.#shippingCountry) return;

    this.#observer = new MutationObserver((mutations) => {
      mutations.forEach(({ target }) => {
        if (target instanceof Element) {
          this.#handleDataCountry();
        }
      });
    });

    this.#observer.observe(this.#shippingCountry, {
      attributes: true,
      attributeFilter: ['data-country']
    });
  };


  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(
      ThemeEvents.itemQuantityUpdate,
      this.#handleCartUpdate
    );

    if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null;
    }
  }
}

if (!customElements.get("complimentary-shipping")) {
  customElements.define("complimentary-shipping", ComplimentaryShipping);
}
